enum ContactType {
  PRIVATE = 'PRIVATE',
  COMPANY = 'COMPANY',
}

export default ContactType;
